import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

const cn = (...classes: Array<ClassValue>) => twMerge(clsx(...classes));

export default cn;
